<div khA11yDialog>
<div class="modal-heading modal-heading-1">
  <div khA11yLabelSource class="label_name">{{ 'RENEW_CLASS_MODAL.PREMIUM_ACCESS_EXPIRED' | translate }}</div>
</div>

<div class="modal-body mission-modal-body">
  {{ 'RENEW_CLASS_MODAL.THIS_PREMIUM_CLASS_HAS_EXPIRED' | translate }}
  <br><br>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="goToContact()">{{ 'RENEW_CLASS_MODAL.CONTACT_US' | translate }}</button>
  <button class="btn btn-default" (click)="cancel()">{{ 'RENEW_CLASS_MODAL.CLOSE' | translate }}</button>
</div>
</div>
